var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_outline_sms",
    "data-name": "vuesax/outline/sms",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sms"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5,12.333H3.833A3.492,3.492,0,0,1,0,8.5V3.833A3.492,3.492,0,0,1,3.833,0H10.5a3.492,3.492,0,0,1,3.833,3.833V8.5A3.492,3.492,0,0,1,10.5,12.333ZM3.833,1A2.49,2.49,0,0,0,1,3.833V8.5a2.49,2.49,0,0,0,2.833,2.833H10.5A2.49,2.49,0,0,0,13.333,8.5V3.833A2.49,2.49,0,0,0,10.5,1Z",
    transform: "translate(0.833 1.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M3.835,3.084a2.478,2.478,0,0,1-1.56-.527L.188.891a.5.5,0,1,1,.62-.78L2.9,1.777a1.591,1.591,0,0,0,1.873,0L6.855.111a.492.492,0,0,1,.7.08.492.492,0,0,1-.08.7L5.388,2.557A2.447,2.447,0,0,1,3.835,3.084Z",
    transform: "translate(4.165 5.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H16V16H0Z",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8bf7fca81a793bc87b34063912597bb5.svg";
export { ForwardRef as ReactComponent };